import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminAddUsersToGroupIcon = (props: IconProps) => (
  <Icon width="13px" height="11px" viewBox="0 0 13 11" {...props}>
    <path d="M4.665 5.25c1.367 0 2.5-1.113 2.5-2.5 0-1.367-1.133-2.5-2.5-2.5a2.505 2.505 0 0 0-2.5 2.5c0 1.387 1.113 2.5 2.5 2.5Zm.977.938H3.669A3.384 3.384 0 0 0 .29 9.585c0 .371.293.664.664.664h7.402a.675.675 0 0 0 .684-.664 3.4 3.4 0 0 0-3.398-3.399Zm6.68-2.032h-.938V3.22a.475.475 0 0 0-.469-.469.463.463 0 0 0-.469.469v.937H9.51a.463.463 0 0 0-.469.469c0 .273.195.469.469.469h.937v.937c0 .274.196.469.469.469a.463.463 0 0 0 .469-.469v-.937h.937a.463.463 0 0 0 .469-.469.475.475 0 0 0-.469-.469Z" />
  </Icon>
);

export default memo(AdminAddUsersToGroupIcon);
